/**
 * 地址验证工具函数
 * 用于判断地址是 EVM 还是 Solana 格式
 */

/**
 * 判断地址是否为 EVM 格式
 * EVM 地址特征：
 * - 长度为 42 个字符
 * - 以 "0x" 开头
 * - 其余字符为十六进制（0-9, a-f, A-F）
 */
const isEVMAddress = (address: string): boolean => {
  if (!address || typeof address !== "string") {
    return false;
  }

  // 检查长度和前缀
  if (address.length !== 42 || !address.startsWith("0x")) {
    return false;
  }

  // 检查是否为有效的十六进制字符串
  const hexRegex = /^0x[0-9a-fA-F]{40}$/;
  return hexRegex.test(address);
};

/**
 * 判断地址是否为 Solana 格式
 * Solana 地址特征：
 * - 长度为 32-44 个字符
 * - 使用 Base58 编码
 * - 不包含 0, O, I, l 字符
 */
const isSolanaAddress = (address: string): boolean => {
  if (!address || typeof address !== "string") {
    return false;
  }

  // Solana 地址长度通常在 32-44 字符之间
  if (address.length < 32 || address.length > 44) {
    return false;
  }

  // Base58 字符集（不包含 0, O, I, l）
  const base58Chars =
    "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";

  // 检查是否只包含 Base58 字符
  for (const char of address) {
    if (!base58Chars.includes(char)) {
      return false;
    }
  }

  return true;
};

/**
 * 验证地址格式并返回详细信息
 * @param address 要验证的地址
 * @returns 验证结果对象
 */
export const validateAddress = (address: string) => {
  return {
    isEVM: isEVMAddress(address),
    isSolana: isSolanaAddress(address),
  };
};
